<template>
  <div style="margin-bottom: 20px">
    <h1 class="item-title">{{ $t('components_invoice_change_state.zhang_dan_lie_biao') }}</h1>
    <div style="margin-bottom: 30px">
      <div v-for="(item, index) in linkedBillList" :key="index" style="margin-bottom: 20px">
        <div style="margin-bottom: 12px; font-size: 13px; color: #666; padding-right: 12px">{{ item.value[0].payableOrgName }} -> {{ item.value[0].receivableOrgName }}</div>
        <custom-table ref="customTb1" tableCode="apply_change_state" :data="item.value" @filter="filterChange" @sort="sortChange"></custom-table>
      </div>
    </div>
    <!-- <div style="margin-bottom: 30px" v-else>
      <div style="margin-bottom: 12px; text-align: right; font-size: 13px; color: #666; padding-right: 12px">
        {{ detail.payableOrgName }} -> {{ detail.receivableOrgName }}
        <span style="margin-left: 12px; color: #00afff; cursor: pointer" @click="onShowPreviewBill()">{{ $t('page_bill_trade_syzd') }}</span>
      </div>
      <custom-table ref="customTb1" tableCode="apply_change_state" :data="billList" @filter="filterChange" @sort="sortChange"></custom-table>
    </div> -->
    <h1 class="item-title">{{ $t('components_invoice_change_state.bghjylx') }}</h1>
    <div style="margin-bottom: 30px">
      <el-radio disabled v-model="newBillTradeState" :label="0">{{ $t('components_invoice_change_state.wei_jiao_yi') }}</el-radio>
      <el-radio disabled v-model="newBillTradeState" :label="100">{{ $t('components_invoice_change_state.guan_bi_jiao_yi') }}</el-radio>
    </div>
    <h1 class="item-title">{{ $t('components_invoice_change_state.bian_geng_yuan_yin') }}</h1>
    <el-input type="textarea" :rows="4" :disabled="model.type === 'watch'" v-model="changeDesc" style="width: 100%"></el-input>
    <!-- 预览账单 -->
    <!-- <preview-bill-change-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false"></preview-bill-change-dialog> -->
  </div>
</template>

<script>
import apis from '@/utils/apis';
// import previewBillChangeDialog from './children/preview_bill_change_dialog.vue';

export default {
  // components: { previewBillChangeDialog },
  props: {
    model: {
      type: Object,
      default() {
        return {
          type: '', // add / edit / watch
          changeId: '', // 新增时为orderId, 编辑查看时为changeId
        };
      },
    },
  },
  data() {
    return {
      // dialogModel: {},
      // dialogVisible: false,
      newBillTradeState: null,
      changeDesc: '',
      billList: [],
      linkedBillList: [],
      detail: {},
      changeId: null,
    };
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    // 获取编辑详情
    getDetail: function () {
      if (this.model.changeId) {
        this.$getJSON(`${apis.billTradeStateInfo}/${this.model.changeId}`).then((res) => {
          this.changeId = this.model.changeId;
          this.detail = res.data.billViewList[0] || {};
          this.linkedBillList = this.arrayGroupBy(res.data.linkedBillList || [], (t) => `${t.payableOrgId}-${t.receivableOrgId}`);
          this.billList = res.data.billViewList;
          this.changeDesc = res.data.changeDesc;
          this.newBillTradeState = this.detail.billTradeState === 0 ? 100 : 0;
        });
      } else {
        const { orderId, deviceNo, termNum, billTradeState } = this.model.row;
        this.$getJSON(apis.billTradeStateLinkedBill, { orderId, deviceNo, termNum, billTradeState }).then((res) => {
          this.detail = this.model.row;
          this.linkedBillList = this.arrayGroupBy(res.data || [], (t) => `${t.payableOrgId}-${t.receivableOrgId}`);
          this.billList = res.data || [];
          this.newBillTradeState = this.detail.billTradeState === 0 ? 100 : 0;
        });
      }
    },
    arrayGroupBy: function (arr, iteratee) {
      const list = [];
      for (const item of arr) {
        const key = typeof iteratee === 'function' ? iteratee(item) : item[iteratee];
        const index = list.findIndex((t) => t.key === key);
        if (index === -1) {
          list.push({ key: key, value: [item] });
        } else {
          list[index].value.push(item);
        }
      }
      return list;
    },
    // 确认保存
    onConfirm(approve) {
      if (this.model.type === 'watch') {
        this.$emit('close');
      }
      this.$postJSON(apis.billTradeStateDraft, {
        changeId: this.changeId,
        changeBills: this.billList,
        contractNo: this.detail.contractNo,
        newBillTradeState: this.newBillTradeState,
        changeDesc: this.changeDesc,
      }).then((res) => {
        if (approve) {
          this.onSubmit(res.data);
          return;
        }
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.$emit('success', this.form);
      });
    },
    // 提交审批
    onSubmit(row) {
      const typeText = this.getDicValue('approval_type', 'change_bill_trade_state');
      this.$postJSON(
        `${apis.apsApproveApprovalApproveStart}/change_bill_trade_state/${row.changeId}`,
        {
          title: [`【${row.contractNo}】`, typeText].join(' '),
          applyReason: row.changeDesc,
        },
        true
      ).then(() => {
        this.$message({
          type: 'success',
          message: this.$t('Common.com_handle_success'),
        });
        this.$emit('success', this.form);
      });
    },
  },
};
</script>

<style lang="scss"></style>
